import type { BoxListItem, BoxProductItem } from "../../../api/WarehouseApi";
import {
  type DestroyConfirmTarget,
  resolveChildBoxDestroyTarget,
  resolveProductDestroyTarget,
} from "./destroy-confirm";

export type DestroyConfirmPlan =
  | { kind: "none" }
  | { kind: "currentBox" }
  | { kind: "childBox"; item: BoxListItem }
  | { kind: "product"; item: BoxProductItem }
  | { kind: "unavailable"; message: string };

export function resolveDestroyConfirmPlan(input: {
  target: DestroyConfirmTarget | null;
  childBoxes: BoxListItem[];
  childProducts: BoxProductItem[];
}): DestroyConfirmPlan {
  const target = input.target;
  if (!target) {
    return { kind: "none" };
  }

  if (target.kind === "currentBox") {
    return { kind: "currentBox" };
  }

  if (target.kind === "childBox") {
    const childBox = resolveChildBoxDestroyTarget({
      target,
      childBoxes: input.childBoxes,
    });
    if (!childBox) {
      return { kind: "unavailable", message: "Коробка уже недоступна" };
    }
    return { kind: "childBox", item: childBox };
  }

  const product = resolveProductDestroyTarget({
    target,
    childProducts: input.childProducts,
  });
  if (!product) {
    return { kind: "unavailable", message: "Товар уже недоступен" };
  }

  return { kind: "product", item: product };
}
